import { CodedError } from '../../CodedError';
import { errorCodes } from '../../constants/errorCodes';

export class SaltoSvnInvalidFieldError extends CodedError {
  static get errorName() {
    return errorCodes.saltoSvnInvalidFieldError.code;
  }

  constructor(message: string = errorCodes.saltoSvnInvalidFieldError.message) {
    super(message);
    this.code = errorCodes.saltoSvnInvalidFieldError.code;
    this.message = `${message} ${errorCodes.saltoSvnInvalidFieldError.code}`;
    this.name = errorCodes.saltoSvnInvalidFieldError.name;
  }
}
